import { User } from '../common/user.model'

export enum SignUpType {
  NEW_LINE = 'NEW_LINE',
  PORTABILITY = 'PORTABILITY',
  EMPTY = '',
}

export enum PortabilityType {
  PREPAID = 'PREPAID',
  POSTPAID = 'POSTPAID',
  EMPTY = '',
}

export enum Owner {
  SAME = 'SAME',
  OTHER = 'OTHER',
  EMPTY = '',
}

export interface DonorOperator {
  id: string
  operator?: string
}

export interface SignUp {
  signUpType: SignUpType
  lineNumber: string
  icc?: string
  donorICC?: string
  iccBalance?: number
  iccAvailable?: boolean
  portabilityType?: PortabilityType
  isSameOwner?: Owner
  donorOwner?: User
  donorOperator?: DonorOperator
  isPortabilityDate?: boolean
  portabilityDate?: string
}
